import styled from 'styled-components';

export const RecentOrdersDescriptionText = styled.p`
  margin-bottom: 2rem;
`;
